import styled from 'styled-components';

export const StyledDashboard = styled.div`
  display: flex;
  gap: 20px;
  color: var(--color-text-main);
  width: 100%;

  > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: calc(100vh - 130px);
  }



  @media (min-width: 1280px) {
    > div {
      width: calc(100% - 920px);
    }
    .chart {
      display: grid;
      width: 900px;
      grid-template-columns: repeat(2, 1fr);
      height: calc(100vh - 130px);
      overflow-y: auto;
      padding-right: 3px;
    }
  }

  @media (max-width: 1280px) {
    flex-direction: column;
    gap: 20px;
    
    > div {
      height: 400px;
      min-width: 457px;
      min-height: 400px;
    }
  }
  }
`;
